enum DrawingUploadFieldsTypeEnum {
    Apartment = 'apartment',
    Floor = 'floor',
    Project = 'project',
    SchemeType = 'schemeType',
    Section = 'section',
}

export default DrawingUploadFieldsTypeEnum;
